/* 🤖 this file was generated by svg-to-ts */
export const iccIconOpen: {
  name: 'open';
  data: string;
} = {
  name: 'open',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10L21 11Z" fill="currentColor"/></svg>`
};
